// layouts/AdminLayout.jsx
import { Outlet, useLocation } from "react-router-dom";

import { useEffect, useState } from "react";
import RouteLoader from "./components/RouteLoader";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";

export default function AdminLayout() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // 🔥 Detect route change
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 300); // smooth UX
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        isMobile={isMobile}
      />

      <AdminHeader
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      <div className="content-wrapper">
        {loading && <RouteLoader />}
        <Outlet />
      </div>
    </div>
  );
}
